<template>
  <fragment>
    <div class="text-h6 font-weight-black">
      {{ title }}
    </div>
    <v-card
      v-for="party in parties"
      :key="party.id"
      elevation="4"
      class="my-2 border-top"
      outlined
    >
      <v-card-text class="black--text">
        <parties-info-card :party="party"></parties-info-card>
      </v-card-text>
    </v-card>
    <v-row class="mx-12">
      <v-col
        v-if="parties.length==0"
        cols="12"
      >
        <div class="mt-9 black--text text-center text-h5 font-weight-black">
          لا يوجد اطراف
        </div>
      </v-col>
    </v-row>
  </fragment>
</template>

<script>
import PartiesInfoCard from './parties-info-card.vue';

export default {
  name: 'PartiesCard',
  components: { PartiesInfoCard },
  props: {
    title: {
      type: String,
      required: true,
    },
    parties: {
      type: Array,
      required: true,
    },
  },
};

</script>
